import React from 'react';

export default class ComponentLink extends React.Component {

  render() {
    const { componentName, mapping, level } = this.props;
    const componentKey = componentName ? componentName.trim().replace(/\s/g, '_').toUpperCase() : '';
    const url = mapping[componentKey] ? mapping[componentKey] : null;

    return (
      <div style={ {
        marginLeft: 2*(level+1)+`rem`,
        display: 'inline-block',
      }}>
        {url ? (
          <a href={url} target="_blank">
            {componentName}
          </a>
        ) : (
          <span>{componentName}</span>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/content/controls/component_link.jsx